import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BeefIcon, LeafyGreenIcon, WheatIcon } from 'lucide-react';
export function JarSystemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 bg-warm-50" data-id="element-93">
      <div className="max-w-6xl mx-auto" data-id="element-94">
        <div className="text-center mb-16" data-id="element-95">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-warm-900 mb-4 font-heading" data-id="element-96">
            El Sistema de los 3 Frascos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-2xl text-gold-dark font-medium" data-id="element-97">
            Cena lista en 5 minutos reales.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-6 text-lg text-warm-800/80 max-w-2xl mx-auto" data-id="element-98">
            Imagina abrir la nevera y tener todo listo. Sin ensuciar ollas. Sin
            tomar decisiones agotadoras después del trabajo.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-99">
          {/* Jar 1 */}
          <motion.div variants={cardVariants} className="bg-white rounded-3xl p-8 shadow-sm border border-warm-100 flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-100">
            <div className="w-20 h-20 bg-cream rounded-full flex items-center justify-center mb-6 text-gold-dark" data-id="element-101">
              <BeefIcon className="w-10 h-10" strokeWidth={1.5} data-id="element-102" />
            </div>
            <h3 className="text-2xl font-bold font-heading text-warm-900 mb-3" data-id="element-103">
              Proteína
            </h3>
            <p className="text-warm-800/70" data-id="element-104">
              Preparada y lista para servir, asegurando saciedad.
            </p>
          </motion.div>

          {/* Jar 2 */}
          <motion.div variants={cardVariants} className="bg-white rounded-3xl p-8 shadow-sm border border-warm-100 flex flex-col items-center text-center hover:shadow-md transition-shadow relative top-0 md:top-8" data-id="element-105">
            <div className="w-20 h-20 bg-cream rounded-full flex items-center justify-center mb-6 text-emerald-600" data-id="element-106">
              <LeafyGreenIcon className="w-10 h-10" strokeWidth={1.5} data-id="element-107" />
            </div>
            <h3 className="text-2xl font-bold font-heading text-warm-900 mb-3" data-id="element-108">
              Vegetales
            </h3>
            <p className="text-warm-800/70" data-id="element-109">
              Cortados y listos para aportar vitaminas sin esfuerzo.
            </p>
          </motion.div>

          {/* Jar 3 */}
          <motion.div variants={cardVariants} className="bg-white rounded-3xl p-8 shadow-sm border border-warm-100 flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-110">
            <div className="w-20 h-20 bg-cream rounded-full flex items-center justify-center mb-6 text-amber-600" data-id="element-111">
              <WheatIcon className="w-10 h-10" strokeWidth={1.5} data-id="element-112" />
            </div>
            <h3 className="text-2xl font-bold font-heading text-warm-900 mb-3" data-id="element-113">
              Carbohidrato
            </h3>
            <p className="text-warm-800/70" data-id="element-114">
              Listo para completar la cena y dar energía estable.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-12 md:mt-24" data-id="element-115">
          <p className="text-2xl md:text-3xl font-heading font-bold text-warm-900 italic" data-id="element-116">
            Solo servir. Comer. Continuar.
          </p>
        </motion.div>
      </div>
    </section>;
}